import { palette } from '@shared/tokens/palette.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  userList: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    gap: '13px',
  },
  userEmail: {
    display: 'flex',
    width: '165px',
    minWidth: '165px',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '10px',
  },
  userTable: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: '1 0 0',
    width: '872px',
    height: '480px',
    color: colors.primaryText,
    backgroundColor: colors.primaryBackground,
    fontFamily: fonts.din2014Regular,
    fontSize: '14px',
    overflow: 'hidden',
  },
  userGuestRows: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    width: '100%',
  },
  userGuestRowsThree: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    width: '100%',
  },
  userGuestRow: {
    display: 'contents',
    color: colors.primaryText,
  },
  userGuestItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 16px',
    borderBottom: `1px solid ${colors.tertiaryBorder}`,
  },
  userTableText: {
    color: palette['grey-500'],
  },
  userHeader: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    width: '100%',
    borderBottom: `1px solid ${colors.tertiaryBorder}`,
  },
  userHeaderThree: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    width: '100%',
    borderBottom: `1px solid ${colors.tertiaryBorder}`,
  },
  headerEmail: {
    display: 'flex',
    width: '165px',
    height: '36px',
    minWidth: '165px',
    alignItems: 'flex-start',
    gap: '10px',
    flexWrap: 'wrap',
  },
  itemEmail: {
    display: 'flex',
    minWidth: ' 36px',
    padding: '8px 16px',
    alignItems: 'center',
    gap: ' 8px',
    alignSelf: 'stretch',
  },
  userEmailItem: {
    display: 'flex',
    padding: '8px 16px',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
  },
});
